export default class Entry {
  constructor() {
    this.entryCode = '';
    this.rankCode = '';
    this.title = '';
    this.entryDate = '';
    this.resultDate = '';
    this.resultCode = '';
    this.thumbnail = '';
    this.alternativeText = '';
    this.status = '';
    this.canRetake = true;
    this.registrationRequired = false;
  }

  public entryCode: string;

  public rankCode: string;

  public title: string;

  public entryDate: string;

  public resultDate: string;

  public resultCode: string;

  public thumbnail: string;

  public alternativeText: string;

  public status: string;

  public canRetake: boolean;

  public registrationRequired: boolean;
}
